mutation DeleteTorahColumnOverlay($id: ID!) {
  deleteTorahColumnOverlay(id: $id) {
    ok
    errors
  }
}
